module.exports = require('./dist/bundle.js');




/*****************
 ** WEBPACK FOOTER
 ** ./~/re-base/index.js
 ** module id = 226
 ** module chunks = 0
 **/